import { Theme } from '@mui/material';

const getTemplateColors = (theme: Theme) => ({
  background: {
    dark: theme.palette.mode === 'dark' ? '#212327' : '#f5f5f5',
  },
  border: {
    default:
      theme.palette.mode === 'dark' ? 'rgb(80 85 89)' : theme.palette.divider,
    white: theme.palette.mode === 'dark' ? '#ffffff' : theme.palette.divider,
  },
  text: {
    white: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary,
  },
});

export const getTemplatesViewSx = (theme: Theme) => {
  const colors = getTemplateColors(theme);

  return {
    templateNameGrid: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
    },
    templateName: {
      fontSize: '1rem',
      fontWeight: 600,
      color: colors.text.white,
      textTransform: 'uppercase',
    },
    configWrapper: {
      minHeight: 115,
      p: 3,
      border: `1px solid ${colors.border.default}`,
      background: colors.background.dark,
      buttonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
      },
    },
    fields: {
      mb: 2,
      fontSize: 17,
      '@media (min-width: 1920px)': {
        fontSize: '1.6rem',
      },
    },
    fullConfig: {
      wrapper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: colors.background.dark,
        color: colors.text.white,
        p: 4,
        width: '60vw',
        maxHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
      },
      header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        closeButton: {
          color: colors.text.white,
          fontSize: '1.5rem',
          minWidth: 'auto',
          padding: 0,
        },
        divider: {
          mt: 1,
          mb: 4,
          border: '1px solid',
          borderColor: colors.border.white,
        },
      },
      fieldsSection: {
        overflowY: 'auto',
        flexGrow: 1,
        fieldsWrapper: { px: 3, mt: 2 },
      },
      footer: {
        mt: 3,
        display: 'flex',
        justifyContent: 'flex-end',
        flexShrink: 1,
      },
    },
  };
};
